import { InvitationsList } from '@/components/InvitationsList';
import { UsersList } from '@/components/UsersList';
import { useOrganization } from '@/hooks/useOrganizations';
import { usePageMeta } from '@/hooks/usePageMeta';
import PageSkeleton from '@/layout/Skeleton';
import { useTranslation } from 'react-i18next';

export default function OrganizationUsers() {
  const organization = useOrganization();
  const { t } = useTranslation('users');
  usePageMeta({ title: [t('page.title')] });

  if (!organization?.id) {
    return <div>{t('page.orgNotFound')}</div>;
  }

  return (
    <PageSkeleton steps={[{ label: t('page.title'), href: '/users' }]}>
      <div className='max-w-screen-md mx-auto px-4 pt-6 w-full flex flex-col gap-4'>
        <UsersList organizationId={organization.id} />

        <InvitationsList organizationId={organization.id} />
      </div>
    </PageSkeleton>
  );
}
